/*! Digital Quran — fix layer (Digital X). Loads before dxl-quran-player.js.
 * 1) quran.ai renamed its Arabic edition key (ar-simple-clean -> ar-uthmani-hafs): aliased so verses render.
 * 2) dxl-translate Cloud Run offline: skipped, translation uses the public fallback
 *    (set window.DXQ_CONFIG = { cloudRun: true } beforehand if it is ever redeployed).
 * 3) quran.ai's edge sometimes 502s: reads are retried. Mushaf pages: see dxl-quran-mushaf.js.
 */
(function () {
  "use strict";
  var CFG = (window.DXQ_CONFIG = Object.assign({ cloudRun: false }, window.DXQ_CONFIG || {}));
  var RUN_HOST = "dxl-translate-933988651513.asia-southeast1.run.app";
  var MCP_HOST = "mcp.quran.ai";
  var LEGACY_AR = "ar-simple-clean";

  /* ---------------------------------------------------------------- fetch shim */
  var nativeFetch = window.fetch.bind(window);

  function jsonResponse(obj) {
    return new Response(JSON.stringify(obj), { status: 200, headers: { "Content-Type": "application/json" } });
  }

  function aliasArabic(rpc) {
    try {
      var c = rpc && rpc.result && rpc.result.content;
      if (!c || !c[0] || typeof c[0].text !== "string") return rpc;
      var j = JSON.parse(c[0].text);
      var r = j && j.results;
      if (r && !r[LEGACY_AR]) {
        var keys = Object.keys(r);
        var k = keys.filter(function (x) { return x.indexOf("ar-") === 0; })[0] || keys[0];
        if (k) {
          r[LEGACY_AR] = r[k];
          c[0].text = JSON.stringify(j);
          if (rpc.result.structuredContent && rpc.result.structuredContent.results) {
            rpc.result.structuredContent.results[LEGACY_AR] = r[k];
          }
        }
      }
    } catch (e) {}
    return rpc;
  }

  function rewriteBody(text, contentType) {
    try {
      if ((contentType || "").indexOf("event-stream") >= 0) {
        return text.split("\n").map(function (line) {
          if (line.indexOf("data:") !== 0) return line;
          var payload = line.slice(5).trim();
          try { return "data: " + JSON.stringify(aliasArabic(JSON.parse(payload))); } catch (e) { return line; }
        }).join("\n");
      }
      return JSON.stringify(aliasArabic(JSON.parse(text)));
    } catch (e) {
      return text;
    }
  }

  // quran.ai's Cloudflare edge intermittently returns 502 (incl. CORS preflight); all calls are reads, so retry.
  var RETRY_DELAYS = [400, 900, 1600, 2600];
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function fetchWithRetry(input, init, attempt) {
    attempt = attempt || 0;
    var aborted = function () { return !!(init && init.signal && init.signal.aborted); };
    return nativeFetch(input, init).then(function (res) {
      if (res.status >= 500 && attempt < RETRY_DELAYS.length && !aborted()) {
        return wait(RETRY_DELAYS[attempt]).then(function () { return fetchWithRetry(input, init, attempt + 1); });
      }
      return res;
    }, function (err) {
      if (attempt < RETRY_DELAYS.length && !aborted()) {
        return wait(RETRY_DELAYS[attempt]).then(function () { return fetchWithRetry(input, init, attempt + 1); });
      }
      throw err;
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";

    if (url.indexOf(RUN_HOST) >= 0 && !CFG.cloudRun) {
      if (/\/qf\/status/.test(url)) return Promise.resolve(jsonResponse({ enabled: false }));
      if (/\/qf\//.test(url)) return Promise.resolve(jsonResponse({ questions: [], hadiths: [] }));
      return Promise.reject(new TypeError("dxq: translator offline"));
    }

    if (url.indexOf(MCP_HOST) >= 0 && !(init && typeof init.body === "string" && init.body.indexOf('"fetch_quran"') >= 0)) {
      return fetchWithRetry(input, init);
    }

    if (url.indexOf(MCP_HOST) >= 0) {
      return fetchWithRetry(input, init).then(function (res) {
        if (!res.ok) return res;
        var ct = res.headers.get("content-type") || "";
        return res.text().then(function (t) {
          var headers = new Headers();
          res.headers.forEach(function (v, k) { if (k !== "content-length" && k !== "content-encoding") headers.set(k, v); });
          return new Response(rewriteBody(t, ct), { status: res.status, statusText: res.statusText, headers: headers });
        });
      });
    }

    return nativeFetch(input, init);
  };

  /* ------------------------------------------------- typography: fix rem scale */
  // Theme root is 10px but the section CSS assumes 16px rem (text rendered at 6–10px). Rescale only its rems.
  var REM_BASE = 16;
  function isQuranStyle(el) {
    var t = el.textContent || "";
    return t.indexOf("#DigitalQuran") >= 0 || t.indexOf(".dxq-hero") >= 0 || t.indexOf("#dxq-") >= 0;
  }
  function fixRem(el) {
    if (el.__dxqRem || el.id === "dxq-fix-css" || !isQuranStyle(el)) return;
    el.__dxqRem = true;
    var t = el.textContent;
    var out = t.replace(/(-?\d*\.?\d+)rem\b/g, function (m, n) {
      return "calc(" + n + " * var(--dxq-rem, " + REM_BASE + "px))";
    });
    if (out !== t) el.textContent = out;
  }
  function scanStyles(root) {
    var list = (root || document).querySelectorAll ? (root || document).querySelectorAll("style") : [];
    for (var i = 0; i < list.length; i++) fixRem(list[i]);
  }
  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === "STYLE") fixRem(n); else if (n.querySelectorAll) scanStyles(n);
        }
      }
    });
    mo.observe(document.documentElement || document, { childList: true, subtree: true });
    document.addEventListener("DOMContentLoaded", function () { scanStyles(); });
    window.addEventListener("load", function () { scanStyles(); setTimeout(function () { mo.disconnect(); }, 4000); });
  } catch (e) {}
  scanStyles();

  /* ----------------------------------------------------------------- UX polish */
  var css = [
    /* Responsive type scale for the Quran section: 16px rem on desktop, a touch tighter on phones */
    ":root{--dxq-rem:16px}@media (max-width:749px){:root{--dxq-rem:14px}}@media (max-width:420px){:root{--dxq-rem:13px}}",
    /* Theme announcement slider overflowed by ~28px on phones -> sideways page wobble */
    "html{overflow-x:clip}",
    ".announcement-bar-section,.announcement-bar,.utility-bar{overflow:hidden;max-width:100vw}",
    /* Drag-to-reorder handles are a desktop affordance; on touch they clutter and fight scrolling */
    "@media (hover:none),(max-width:749px){#DigitalQuran .dxq-drag{display:none!important}}",
    /* On desktop, tuck the handle bottom-right and reveal it on hover so it never covers tile badges */
    "#DigitalQuran .dq-tile .dxq-drag{top:auto!important;bottom:12px!important;right:12px!important;opacity:0!important}",
    "#DigitalQuran .dq-tile:hover .dxq-drag,#DigitalQuran .dq-tile .dxq-drag:focus-visible{opacity:.75!important}",
    /* Keep the last surah cards and footer clear of the fixed audio bar */
    "#DigitalQuran .wrap{padding-bottom:calc(var(--dxq-pad,0px) + 8px)}",
    /* Reader: comfortable Uthmani rendering */
    "#DigitalQuran .rv-ar{font-family:'Amiri Quran','Amiri','Scheherazade New','Noto Naskh Arabic',serif;word-spacing:.06em}",
    "#DigitalQuran .rv-ar .rv-n{font-size:.78em;margin-inline-start:.35em;white-space:nowrap}",
    "#DigitalQuran .rv-tr{line-height:1.7}",
    /* Surah grid: cards in a row share one height (long meta lines no longer make rows ragged) */
    "#DigitalQuran #dxq-list>li{min-width:0}#DigitalQuran #dxq-list>li:not([style*='none']){display:flex}",
    "#DigitalQuran #dxq-list>li>.card{flex:1;min-width:0}",
    "#DigitalQuran #dxq-list .meta{min-width:0}",
    /* Smoother focus + tap targets */
    "#DigitalQuran .card-btns button{min-width:40px;min-height:40px}",
    "@media (prefers-reduced-motion:reduce){#DigitalQuran *{animation-duration:.01ms!important;transition-duration:.01ms!important}}"
  ].join("");
  function addHeadAssets() {
    var head = document.head || document.documentElement;
    if (!head) return false;
    if (!document.getElementById("dxq-fix-css")) {
      var st = document.createElement("style");
      st.id = "dxq-fix-css";
      st.textContent = css;
      head.appendChild(st);
      /* Amiri Quran: proper Uthmani glyph support for the reader */
      var fl = document.createElement("link");
      fl.rel = "stylesheet";
      fl.href = "https://fonts.googleapis.com/css2?family=Amiri+Quran&display=swap";
      head.appendChild(fl);
    }
    return true;
  }
  if (!addHeadAssets()) document.addEventListener("DOMContentLoaded", addHeadAssets);

  /* Reserve space under content equal to the audio bar's height while it is up */
  function syncPad() {
    var p = document.getElementById("dxq-player");
    var root = document.getElementById("DigitalQuran");
    if (!p || !root) return;
    var up = p.classList.contains("up");
    root.style.setProperty("--dxq-pad", up ? Math.round(p.getBoundingClientRect().height) + "px" : "0px");
  }
  function watchPlayer() {
    var p = document.getElementById("dxq-player");
    if (!p) return false;
    syncPad();
    try { new MutationObserver(syncPad).observe(p, { attributes: true, attributeFilter: ["class"] }); } catch (e) {}
    window.addEventListener("resize", syncPad);
    return true;
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchPlayer);
  } else {
    watchPlayer();
  }

  /* Tajweed rule names: "Senyap" is Malay; show "Silent" in English mode */
  function tajLang() {
    try { if (typeof lang === "string") return lang; } catch (e) {}
    try { return localStorage.getItem("quran-lang") === "ms" ? "ms" : "en"; } catch (e) { return "en"; }
  }
  function syncTajNames() {
    var nm = tajLang() === "ms" ? "Senyap" : "Silent";
    try {
      if (typeof TAJ_NAME === "object" && TAJ_NAME) TAJ_NAME.slnt = nm;
      if (typeof TAJ_RULES === "object" && TAJ_RULES) TAJ_RULES.forEach(function (r) { if (r[0] === "slnt") r[1] = nm; });
    } catch (e) {}
    var els = document.querySelectorAll("#DigitalQuran b.tj-slnt, .taj-tip b, .taj-legend [data-tj='slnt']");
    for (var i = 0; i < els.length; i++) {
      var t = els[i].textContent.trim();
      if (t === "Senyap" || t === "Silent") els[i].textContent = nm;
    }
  }
  document.addEventListener("click", function (e) {
    var t = e.target && e.target.closest && e.target.closest("#dxq-langEn, #dxq-langMs, [data-dqh-lang]");
    if (t) setTimeout(syncTajNames, 0);
  }, true);
  window.addEventListener("load", syncTajNames);
  document.addEventListener("DOMContentLoaded", function () { setTimeout(syncTajNames, 0); });
})();
